import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhysicalBefore = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 235 100",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 1.5
	},
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "axis",
		children: [
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1.0051,0,0,1.0051,-146.214,-284.005)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M159.92,350.334L363.949,350.334",
					style: {
						fill: "none",
						stroke: "black",
						strokeOpacity: .05,
						strokeWidth: "0.99px"
					}
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "matrix(1,0,0,1,-877.16,-66.597)",
				children: [/* @__PURE__ */ _jsx("g", { transform: "matrix(13,0,0,13,1095.64,150.104)" }), /* @__PURE__ */ _jsxs("text", {
					x: "1059.3px",
					y: "150.104px",
					style: {
						fontFamily: "'Aileron-Regular', 'Aileron'",
						fontSize: 13,
						fill: "rgb(183,183,183)"
					},
					children: [
						"T",
						/* @__PURE__ */ _jsx("tspan", {
							x: "1066.45px ",
							y: "150.104px ",
							children: "o"
						}),
						"day"
					]
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "matrix(1,0,0,1,-989.296,-104.452)",
				children: [/* @__PURE__ */ _jsx("g", { transform: "matrix(13,0,0,13,1074.72,186.377)" }), /* @__PURE__ */ _jsx("text", {
					x: "1003.97px",
					y: "186.377px",
					style: {
						fontFamily: "'Aileron-Regular', 'Aileron'",
						fontSize: 13,
						fill: "rgb(183,183,183)"
					},
					children: "90 days ago"
				})]
			})
		]
	}), /* @__PURE__ */ _jsxs("g", {
		id: "physical-BEFORE",
		transform: "matrix(1,0,0,1,0.324336,4.81514)",
		children: [/* @__PURE__ */ _jsxs("g", {
			transform: "matrix(1,0,0,1,-1085.35,-215.033)",
			children: [/* @__PURE__ */ _jsx("g", { transform: "matrix(15,0,0,15,1303.25,243.961)" }), /* @__PURE__ */ _jsxs("text", {
				x: "1268.22px",
				y: "243.961px",
				style: {
					fontFamily: "'Aileron-Black', 'Aileron'",
					fontWeight: 900,
					fontSize: 15,
					fill: "rgb(255,152,0)"
				},
				children: ["F", /* @__PURE__ */ _jsx("tspan", {
					x: "1277.25px 1288.08px 1293.02px ",
					y: "243.961px 243.961px 243.961px ",
					children: "AIR"
				})]
			})]
		}), /* @__PURE__ */ _jsx("g", {
			id: "physical_operations",
			transform: "matrix(1.79293,0,0,1.45026,-271.913,-444.424)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M159.612,335.386C159.612,335.386 208.373,332.478 228.855,331.793C245.143,331.249 259.925,334.899 272.538,335.101",
				style: {
					fill: "none",
					stroke: "rgb(255,152,0)",
					strokeWidth: "1.75px"
				}
			})
		})]
	})]
});
export default SvgPhysicalBefore;
